/** Frontmatter for the "playoff-prep" article; the Body lives in playoff-prep.jsx. */
const meta = {
  slug: 'playoff-prep',
  title: 'Playoff Prep: Building for Weeks 15–17',
  category: 'Playoffs',
  excerpt: 'The regular season gets you in. A little schedule homework in November decides who actually lifts the trophy.',
  readMinutes: 5,
  date: '2026-07-16',
};

export default meta;
